export enum ErrorCode {
  StaleRecord = 1,
  MoreRecentVersionRecordExists,
  ArticlePublished,
  ArticleStateStopsSave,
  ErrorRaisingSpikeEvent,
  StateChangeNotAllowedForThisUser,
  PublishEventRaisingFailed,
  StateChangeNotAllowed,
  UnpublishedVersionAlreadyExists,
}